import { _js } from '@ifixit/localize';
import { sendReactNativeMessage } from '@ifixit/utils';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { Auth } from 'Shared/auth';
import { Modal } from 'Shared/modal';

onDomReady(() => {
   // Success button (NOT DATA ENTRY VERSION)
   const successButton = $('successButton');
   const doneButton = $('doneButton');
   const cancelCompleted = $('cancelComplete');

   const toggleSuccessButton = success => {
      if (success) {
         successButton.addClass('hidden');
         doneButton.removeClass('hidden');
         cancelCompleted.removeClass('hidden');
      } else {
         doneButton.addClass('hidden');
         successButton.removeClass('hidden');
         cancelCompleted.addClass('hidden');
      }
   };

   when(cancelCompleted, () => {
      cancelCompleted.addEvent('click', ev => {
         const text = doneButton.get('text');
         doneButton.set('text', _js('Processing...'));
         ev.stop();

         new Request.API_2_0('guides/' + App.guideid + '/completed', {
            method: 'DELETE',
            onSuccess: response => {
               trackAnalyticsCustomEvent({
                  eventCategory: 'Guide Author Reward',
                  eventAction: 'Guide Author Reward - Cancel points',
               });
               toggleSuccessButton(false);
               doneButton.set('text', text);
            },
            onError: response => {
               Modal.alert(response.fail);
            },
         }).send();
      });
   });

   when(successButton, () => {
      successButton.addEvent('click', ev => {
         ev.stop();
         successButton.disabled = true;
         const enableButton = () => {
            successButton.disabled = false;
         };

         trackAnalyticsCustomEvent({
            eventCategory: 'Guide Author Reward',
            eventAction: 'Guide Author Reward - Form "Give the author +30 points" - Submit',
         });

         Auth.required({
            from: successButton,
            message: _js('Log in to record that you completed a repair.'),
            onAuthorize: () => {
               const text = successButton.get('text');
               successButton.set('text', _js('Processing...'));
               new Request.API_2_0('guides/' + App.guideid + '/completed', {
                  method: 'PUT',
                  onSuccess: response => {
                     enableButton();
                     toggleSuccessButton(true);
                     successButton.set('text', text);
                  },
                  onError: response => {
                     enableButton();
                     Modal.alert(response.fail);
                  },
                  onFailure: (response, message) => {
                     enableButton();
                     Modal.alert(message);
                  },
               }).send({ langid: App.langid });
               sendReactNativeMessage({
                  type: 'review_prompt_requested',
                  trigger: 'Guide Completion Button',
               });
            },
            onCancel: enableButton,
         });
      });
   });

   when($('halfwayButton'), halfwayButton => {
      halfwayButton.addEvent('click', function (ev) {
         const divider = new Element('div', { class: 'hrContentMinor' });
         const container = new Element('div', { id: 'guideSteps' });

         $$('.step')
            .reverse()
            .each(step => {
               container.adopt(step, divider.clone());
            });

         container.replaces($('guideSteps'));

         // Scroll to the last step (which is now at the top of the page)
         $$('.step')[0].jumpTo({ offset: 5 });

         // Update conclusion banner
         $('halfwayConclusion').addClass('hidden');
         $('finishedConclusion').removeClass('hidden');

         // Update conclusion button
         this.addClass('hidden');
         $('successButton').removeClass('hidden');
      });
   });

   const trackGuideComplete = (entries, guideCompleteObserver) => {
      entries.forEach(entry => {
         if (entry.isIntersecting) {
            trackAnalyticsCustomEvent({
               eventCategory: 'Guide Completion',
               eventAction: 'Guide Completion - Scroll to Complete - Scroll',
            });
            guideCompleteObserver.unobserve(entry.target);
         }
      });
   };

   const guideCompleteDiv = document.querySelector('.guide-complete');
   if (guideCompleteDiv) {
      const guideCompleteObserver = new IntersectionObserver(trackGuideComplete);
      guideCompleteObserver.observe(guideCompleteDiv); // Start observing the target element
   }
});
